import { RepoContext } from "@automerge/react";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";

import { Toaster } from "@/components/ui/sonner";
import { repo } from "@/lib/automerge-repo";

export function FullScreenLoader({
  message = "Loading project…",
}: {
  message?: string;
}) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-3 bg-background text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

function RootComponent() {
  return (
    <RepoContext.Provider value={repo}>
      <main className="flex-1">
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
        <Toaster richColors />
      </main>
    </RepoContext.Provider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
